document.addEventListener("DOMContentLoaded", function () {
	// Function to update the pseudo-element width
	function updatePseudoElementWidth(patternContainer) {
		const ukContainer = patternContainer.querySelector(".uk-container");

		if (ukContainer && patternContainer) {
			const ukContainerOffset = ukContainer.getBoundingClientRect().left;
			const ukContainerPadding = 32; // Padding-left in px
			const adjustedWidth = ukContainerOffset + ukContainerPadding;

			patternContainer.style.setProperty("--pseudo-width", `${adjustedWidth}px`);
		}
	}

	// Function to load/reset and play the Lottie animation for a specific container
	function loadAndPlayLottieAnimation(container, makeVisibleOnLoad = true) {
		const containerId = container.id || container.className.split(" ").join("-");

		if (!container) {
			return;
		}

		// Opacity is now controlled by the calling function based on Swiper events
		// However, ensure it's not accidentally '0' if called directly without pre-hiding
		if (makeVisibleOnLoad && container.style.opacity === "0") {
		}

		const animationPath = container.dataset.animationPath;

		if (!animationPath) {
			if (container.lottieInstance) {
				container.lottieInstance.destroy();
				container.lottieInstance = null;
			}
			container.removeAttribute("style");
			container.innerHTML = "";
			if (makeVisibleOnLoad) container.style.opacity = "1";
			return;
		}

		if (container.lottieInstance) {
			container.lottieInstance.destroy();
			container.lottieInstance = null;
		}

		if (container.lottiePlayTimeout) {
			clearTimeout(container.lottiePlayTimeout);
			container.lottiePlayTimeout = null;
		}

		container.innerHTML = "";

		const animation = window.lottie.loadAnimation({
			container: container,
			renderer: "svg",
			loop: false,
			autoplay: false,
			path: animationPath,
		});
		container.lottieInstance = animation;

		animation.addEventListener("DOMLoaded", () => {
			animation.play();
			if (makeVisibleOnLoad) {
				container.style.opacity = "1";
			}
		});

		const commonErrorHandler = (eventType) => {
			if (container.lottieInstance === animation) {
				container.lottieInstance.destroy();
				container.lottieInstance = null;
				container.innerHTML = "";
				if (makeVisibleOnLoad) container.style.opacity = "1";
			}
		};
		animation.addEventListener("data_failed", () => commonErrorHandler("data_failed"));
		animation.addEventListener("error", () => commonErrorHandler("error"));
	}

	// Function to animate the pseudo-element
	function triggerPseudoElementAnimation(patternContainer) {
		if (patternContainer) {
			// Clear any existing timeouts for this specific patternContainer
			if (patternContainer._animationTimeouts) {
				patternContainer._animationTimeouts.forEach(clearTimeout);
			}
			patternContainer._animationTimeouts = [];

			// Reset classes and force reflow
			patternContainer.classList.remove("animate-expand", "animate-retract");
			void patternContainer.offsetWidth; // Force reflow

			updatePseudoElementWidth(patternContainer);
			patternContainer.classList.add("animate-expand");

			const timeout1 = setTimeout(() => {
				patternContainer.classList.remove("animate-expand");
				patternContainer.classList.add("animate-retract");

				const timeout2 = setTimeout(() => {
					patternContainer.classList.remove("animate-retract");
				}, 1500); // Duration of retract animation
				patternContainer._animationTimeouts.push(timeout2);
			}, 4500); // Time before retract starts
			patternContainer._animationTimeouts.push(timeout1);
		}
	}

	/**
	 * Gets the Swiper autoplay delay defined via the 'swiper' attribute on the container.
	 * This delay is set in Twig using ACF (block.slide_duration).
	 * Returns a fallback value (default 4200ms) if parsing fails.
	 */
	function getSwiperAnimationDelay(container, fallback = 4200) {
		if (!container) return fallback;
		const attr = container.getAttribute("swiper");
		if (!attr) return fallback;

		try {
			const parsed = JSON.parse(attr.replace(/&quot;/g, '"').replace(/&amp;/g, "&"));
			let delay = parsed?.autoplay?.delay;

			delay = typeof delay === "string" ? parseInt(delay, 10) : delay;

			if (typeof delay === "number" && !isNaN(delay)) {
				return delay;
			}
		} catch (e) {
			// console.warn("Failed to parse Swiper delay from swiper attribute:", e);
		}
		// console.warn("[Swiper Delay] fallback used:", fallback, "ms for container:", container);
		return fallback;
	}

	function initializeHeroAnimationsWithSwiper(swiperInstance, swiperContainerElement) {
		const manageLottieOnSlide = (slideElement, action) => {
			const mainLottieContainers = slideElement.querySelectorAll(".heroMainLottieContainer");
			const heroLottieContainers = slideElement.querySelectorAll(".heroLottieContainer");
			const pattern = slideElement.querySelector(".heroSection__sliderPattern.-desktopSlider");
			const title = slideElement.querySelector(".heroSection__titleSlideDown");

			if (action === "hide") {
				// Hide all lottie containers to prepare for the transition
				const allLottie = [...mainLottieContainers, ...heroLottieContainers];
				allLottie.forEach((lc) => {
					if (lc) {
						lc.style.display = "none";
					}
				});
			} else if (action === "initAndShow") {
				// Always initialize heroMainLottieContainer
				mainLottieContainers.forEach((lc) => {
					if (lc) {
						lc.style.display = "block";
						lc.style.opacity = "0";
						loadAndPlayLottieAnimation(lc, true);
					}
				});

				// Initialize heroLottieContainer and pattern only on desktop
				if (window.matchMedia("(min-width: 1025px)").matches) {
					heroLottieContainers.forEach((lc) => {
						if (lc) {
							lc.style.display = "block";
							lc.style.opacity = "0";
							loadAndPlayLottieAnimation(lc, true);
						}
					});

					if (pattern) {
						triggerPseudoElementAnimation(pattern);
					}
				}

				if (title && title.classList.contains("initial-cursor")) {
					title.classList.remove("slideDownActive");
					void title.offsetWidth;
					const fullDelay = getSwiperAnimationDelay(swiperContainerElement);
					const animationDelay = Math.max(0, fullDelay - 500);
					setTimeout(() => {
						title.classList.add("slideDownActive");
					}, animationDelay);
				}
			}
		};

		swiperInstance.on("slideChangeTransitionStart", function () {
			this.slides.forEach((slide) => manageLottieOnSlide(slide, "hide"));
		});

		swiperInstance.on("slideChangeTransitionEnd", function () {
			const activeSlide = this.slides[this.activeIndex];
			if (activeSlide) {
				manageLottieOnSlide(activeSlide, "initAndShow");
			}
		});

		// Initial setup for the very first active slide
		if (swiperInstance.slides && swiperInstance.slides.length > 0 && swiperInstance.activeIndex !== undefined) {
			const initialActiveSlide = swiperInstance.slides[swiperInstance.activeIndex];
			if (initialActiveSlide) {
				manageLottieOnSlide(initialActiveSlide, "initAndShow");
			}
		} else {
			swiperInstance.once("init", function () {
				const initialActiveSlide = this.slides[this.activeIndex];
				if (initialActiveSlide) {
					manageLottieOnSlide(initialActiveSlide, "initAndShow");
				}
			});
		}
	}

	// Set up slide-specific animations
	function trySetupSlideAnimations(attempts = 0) {
		const swiperContainer = document.querySelector(".heroSection__slider");

		if (!swiperContainer) {
			return;
		}

		const slides = swiperContainer.querySelectorAll(".swiper-slide");

		if (slides.length === 1) {
			// Single slide scenario: treat like a static hero animation
			const singleSlide = slides[0];
			const lottieContainer = singleSlide.querySelector(".heroLottieContainer");
			const mainLottieContainer = singleSlide.querySelector(".heroMainLottieContainer");
			const patternContainer = singleSlide.querySelector(".heroSection__sliderPattern.-desktopSlider");

			// Always initialize main lottie
			if (mainLottieContainer) {
				loadAndPlayLottieAnimation(mainLottieContainer);
			}

			// heroLottieContainer and its associated pattern animation are desktop-only.
			if (window.matchMedia("(min-width: 1025px)").matches) {
				if (lottieContainer) {
					// This function also handles re-triggering the pattern animation on loop.
					loadAndPlayStaticLottie(lottieContainer, patternContainer);
				}
				// Trigger the pattern animation once initially.
				// If lottieContainer exists, it will be re-triggered on loop.
				if (patternContainer) {
					triggerPseudoElementAnimation(patternContainer);
				}
			}
			return; // Do not proceed with Swiper instance initialization for a single slide
		}

		// Multi-slide scenario: proceed with Swiper instance initialization
		const swiperInstance = swiperContainer.swiper;

		if (swiperInstance) {
			initializeHeroAnimationsWithSwiper(swiperInstance, swiperContainer);
		} else if (attempts < 20) {
			// Try up to 20 times (e.g., 10 seconds with 500ms interval)
			setTimeout(() => trySetupSlideAnimations(attempts + 1), 500);
		} else {
			// console.warn("trySetupSlideAnimations: Swiper instance not found after multiple attempts.");
		}
	}

	// Function to load, configure, and play Lottie for static hero blocks
	function loadAndPlayStaticLottie(container, patternContainerForLoop) {
		if (!container) return;

		// Clear previous animation if any
		if (container.lottieInstance) {
			container.lottieInstance.destroy();
			container.lottieInstance = null;
		}
		while (container.firstChild) {
			container.removeChild(container.firstChild);
		}

		const animationPath = container.dataset.animationPath;
		if (animationPath) {
			const animation = window.lottie.loadAnimation({
				container: container,
				renderer: "svg",
				loop: true,
				autoplay: false,
				path: animationPath,
			});
			container.lottieInstance = animation;

			animation.addEventListener("DOMLoaded", () => {
				animation.play();
				// If a patternContainer is provided, set up its animation to re-trigger on Lottie loopComplete
				if (patternContainerForLoop) {
					animation.removeEventListener("loopComplete"); // Ensure no multiple listeners
					animation.addEventListener("loopComplete", () => {
						triggerPseudoElementAnimation(patternContainerForLoop);
					});
				}
			});

			// Optional: Add generic error listeners if needed
			// animation.addEventListener("data_failed", () => { ... });
			// animation.addEventListener("error", () => { ... });
		} else {
			// console.warn("No animation path for static Lottie container:", container);
		}
	}

	// Function to set up animations for static hero blocks
	function setupStaticHeroAnimations() {
		const staticHeroElements = document.querySelectorAll(".heroSection__static.-hasAnimation");

		staticHeroElements.forEach((staticHero) => {
			const lottieContainer = staticHero.querySelector(".heroLottieContainer");
			const mainLottieContainer = staticHero.querySelector(".heroMainLottieContainer");
			const patternContainer = staticHero.querySelector(".heroSection__staticPattern.-hasAnimation");

			// Main Lottie animation runs on all screen sizes.
			if (mainLottieContainer) {
				loadAndPlayLottieAnimation(mainLottieContainer);
			}

			// heroLottieContainer and pattern animation are for desktop only.
			if (window.matchMedia("(min-width: 1025px)").matches) {
				// Lottie animation for static hero (will also trigger pattern animation on loop)
				if (lottieContainer) {
					loadAndPlayStaticLottie(lottieContainer, patternContainer);
				}

				// Initial pseudo-element animation for static hero (triggers once on load).
				// If lottieContainer is present, it will re-trigger the pattern on loop.
				// If not, it just runs once.
				if (patternContainer) {
					triggerPseudoElementAnimation(patternContainer);
				}
			}
		});
	}

	// Initialize Swiper-dependent animations
	trySetupSlideAnimations();

	// Initialize static hero animations (does not depend on Swiper)
	setupStaticHeroAnimations();
	window.addEventListener("resize", () => {
		const patternContainers = document.querySelectorAll(".heroSection__sliderPattern.-desktopSlider, .heroSection__static .heroSection__staticPattern.-hasAnimation");
		patternContainers.forEach(updatePseudoElementWidth);
	});
});
